<div class="ingest-panel" [class.ingest-panel--compact]="compact()">
  <div class="ingest-panel__status">
    <span
      class="status-dot"
      [class.status-dot--online]="ingestReady()"
      [class.status-dot--offline]="!ingestReady()"
      aria-hidden="true"
    ></span>
    <div class="ingest-panel__status-copy">
      <p class="ingest-panel__label">
        {{ 'app.patrol.roblox.cockpit.health.statusLabel' | translate }}
      </p>
      <div class="ingest-panel__value-row">
        @if (isCheckingHealth() && !health()) {
          <p class="ingest-panel__value ingest-panel__value--muted">
            {{ 'app.patrol.roblox.cockpit.health.checking' | translate }}
          </p>
        } @else if (healthError()) {
          <p class="ingest-panel__value ingest-panel__value--error">
            {{
              'app.patrol.roblox.cockpit.health.errors.' + healthError()!
                | translate
            }}
          </p>
        } @else {
          <p class="ingest-panel__value">
            {{
              (ingestReady()
                ? 'app.patrol.roblox.cockpit.health.ingestOnline'
                : 'app.patrol.roblox.cockpit.health.ingestOffline'
              ) | translate
            }}
          </p>
        }
        <button
          type="button"
          class="ingest-panel__refresh"
          [class.ingest-panel__refresh--spinning]="isCheckingHealth()"
          [disabled]="isCheckingHealth()"
          [attr.aria-label]="
            'app.patrol.roblox.cockpit.health.refresh' | translate
          "
          (click)="refresh()"
        >
          <img
            src="/public/svgs/refresh.svg"
            alt=""
            width="14"
            height="14"
            aria-hidden="true"
          />
        </button>
      </div>
      @if (health(); as ingestHealth) {
        <ul class="ingest-panel__details">
          <li>
            {{
              (ingestHealth.ingestEnabled
                ? 'app.patrol.roblox.cockpit.health.ingestEnabled'
                : 'app.patrol.roblox.cockpit.health.ingestDisabled'
              ) | translate
            }}
          </li>
          <li>
            {{
              (ingestHealth.allowedUniversesConfigured
                ? 'app.patrol.roblox.cockpit.health.allowlistOn'
                : 'app.patrol.roblox.cockpit.health.allowlistOff'
              ) | translate
            }}
          </li>
        </ul>
      }
    </div>
  </div>
</div>
